import React from 'react';
import Head from 'next/head';
import { CCPARequestStyles } from './CCPARequest.styled';
// import CCPAForm from './CCPAForm';
import CCPAForm from '@components/LegalPrivacy/Privacy/CCPAForm';

const CCPA = () => {
  return (
    <CCPARequestStyles>
      <Head htmlAttributes={{ lang: 'en' }}>
        <title>Data Privacy Request Form | Clayton Homes</title>
        <meta name="description" content="Data Privacy Request Form" />
      </Head>
      <div className="ccpa-body">
        <CCPAForm />
      </div>
    </CCPARequestStyles>
  );
};

export default CCPA;
